module.exports = __webpack_public_path__ + "img/adulto44.9ca3c2fa.jpg";